import "./home.scss";

export const Home = () => {
  return (
    <div className="home" id="home">
      <div className="myAnimation section">
        <div className="animated-title">
          <div className="text-top">
            <div>
              <span>Roberto</span>
              <span>Carro Gastélum</span>
            </div>
          </div>
          <div className="text-bottom">
            <div>Web developer</div>
          </div>
        </div>
      </div>
    </div>
  );
};
